<div class="container-fluid p-0">
  <div class="card shadow-sm border-0">
    <!-- View Mode -->
    <div
      class="card-body p-4"
      *ngIf="!(entry.identifier == 'new' || editEntry == true)"
    >
      <div class="d-flex justify-content-between align-items-start mb-1">
        <div>
          <h2 class="card-title font-weight-bold mb-1">
            {{ entry.identifier }}
          </h2>
          <h6 class="card-subtitle mt-1 font-weight-bold">
            {{ entry.serial }}
          </h6>
        </div>
        <button class="btn btn-outline-primary" (click)="edit($event, entry)">
          <i class="bi bi-pencil-square me-2"></i>Edit
        </button>
      </div>
      <hr class="my-4" />
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label medium mb-1 font-weight-bold"
              >Handle</label
            >
            <p class="mb-0">{{ entry.handle || "-" }}</p>
          </div>
          <div class="mb-3">
            <label class="form-label medium mb-1 font-weight-bold"
              >Series</label
            >
            <p class="mb-0">{{ entry.series || "-" }}</p>
          </div>
          <div class="mb-3">
            <label class="form-label medium mb-1 font-weight-bold"
              >Manufacturer</label
            >
            <p class="mb-0">{{ entry.manufacturer || "-" }}</p>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label medium mb-1 font-weight-bold"
              >Factory Mode</label
            >
            <p class="mb-0">{{ entry.factoryMode || "-" }}</p>
          </div>
          <div class="mb-3">
            <label class="form-label font-weight-bold medium mb-1">Batch</label>
            <p class="mb-0">{{ entry.batch || "-" }}</p>
          </div>
          <div class="mb-3">
            <label class="form-label medium mb-1 font-weight-bold"
              >Secret/PSK</label
            >
            <p class="mb-0 text-truncate" style="max-width: 250px">
              {{ entry.secret || "-" }}
            </p>
          </div>
        </div>
      </div>

      <hr class="my-4" />

      <div class="row medium">
        <div class="col-md-4">
          <div class="mb-2">
            <label class="form-label medium mb-1 font-weight-bold"
              >Activated On</label
            >
            <p class="mb-0">{{ entry.activatedOn || "-" }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-2">
            <label class="form-label medium mb-1 font-weight-bold"
              >Created On</label
            >
            <p class="mb-0">{{ entry.createdOn || "-" }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-2">
            <label class="form-label medium mb-1 font-weight-bold"
              >Modified On</label
            >
            <p class="mb-0">{{ entry.modifiedOn || "-" }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Mode -->
    <div
      class="card-body p-4"
      *ngIf="entry.identifier == 'new' || editEntry == true"
    >
      <h4 class="card-title mb-4">
        {{ isNew ? "Add New Gateway" : "Edit Gateway" }}
      </h4>

      <form>
        <div class="row g-3">
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label font-weight-bold">Serial Number</label>
              <input
                class="form-control"
                [(ngModel)]="entry.serial"
                placeholder="Enter serial number"
                type="text"
                name="serial"
                [readonly]="!isNew"
              />
              <div class="form-text" *ngIf="!isNew">
                Serial number cannot be changed
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label font-weight-bold">Series</label>
              <input
                class="form-control"
                [(ngModel)]="entry.series"
                placeholder="Enter series"
                type="text"
                name="series"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label font-weight-bold">Handle</label>
              <input
                class="form-control"
                [(ngModel)]="entry.handle"
                placeholder="Enter handle"
                type="text"
                name="handle"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label font-weight-bold">Factory Mode</label>
              <input
                class="form-control"
                [(ngModel)]="entry.factoryMode"
                placeholder="Enter factory mode"
                type="text"
                name="factoryMode"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label font-weight-bold">Batch</label>
              <input
                class="form-control"
                [(ngModel)]="entry.batch"
                placeholder="Enter batch"
                type="text"
                name="batch"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label font-weight-bold">Manufacturer</label>
              <select
                class="form-control"
                name="manufacturer"
                [(ngModel)]="entry.manufacturer"
              >
                <option value="" disabled selected>Select manufacturer</option>
                <option *ngFor="let manu of manufacturers" [value]="manu.value">
                  {{ manu.display }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between mt-4 pt-3 border-top">
          <button
            (click)="update($event, entry)"
            class="btn btn-primary"
            type="button"
          >
            <i class="bi bi-check-circle me-2"></i
            >{{ isNew ? "Add Gateway" : "Save Changes" }}
          </button>

          <div>
            <!-- <button
              *ngIf="!isNew"
              (click)="delete($event, entry)"
              class="btn btn-outline-danger me-2 mx-2"
              type="button"
            >
              <i class="bi bi-trash me-2"></i>Delete
            </button> -->
            <button
              (click)="cancel($event)"
              class="btn btn-outline-secondary"
              type="button"
            >
              <i class="bi bi-x-circle me-2"></i>Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
